import { useEvaluateInAppQuery } from '../../__generated__/chirp/com/hubspot/purchase/motions/rpc/PurchaseMotionsEvaluationService.hooks';
import { isValidTalkToSalesPurchaseMotion } from '../utils/purchaseMotionTypeGuards';
const isValidPurchaseMotion = motion => {
  return typeof motion === 'string';
};
export const usePurchaseMotionForAssignability = ({
  isAssignable,
  apiName
}) => {
  var _data$purchaseMotions, _data$purchaseMotions2;
  const {
    data,
    loading,
    error
  } = useEvaluateInAppQuery({
    skip: isAssignable !== undefined,
    variables: {
      productApiNames: [apiName],
      locations: ['TALK_TO_SALES_BUTTON']
    }
  });
  if (isAssignable !== undefined) {
    return {
      loading: false,
      error: undefined,
      purchaseMotion: isAssignable ? 'TALK_TO_SALES' : 'TALK_TO_SALES_FALLBACK'
    };
  }
  if (loading || error) {
    return {
      loading,
      error: error instanceof Error ? error : undefined,
      purchaseMotion: undefined
    };
  }
  const chirpPurchaseMotions = (_data$purchaseMotions = data === null || data === void 0 || (_data$purchaseMotions2 = data.purchaseMotionsMapping) === null || _data$purchaseMotions2 === void 0 || (_data$purchaseMotions2 = _data$purchaseMotions2.productsByLocationString) === null || _data$purchaseMotions2 === void 0 || (_data$purchaseMotions2 = _data$purchaseMotions2.TALK_TO_SALES_BUTTON) === null || _data$purchaseMotions2 === void 0 || (_data$purchaseMotions2 = _data$purchaseMotions2.purchaseMotionsByProductApiName) === null || _data$purchaseMotions2 === void 0 || (_data$purchaseMotions2 = _data$purchaseMotions2[apiName]) === null || _data$purchaseMotions2 === void 0 ? void 0 : _data$purchaseMotions2.purchaseMotions) !== null && _data$purchaseMotions !== void 0 ? _data$purchaseMotions : [];
  const validPurchaseMotions = chirpPurchaseMotions.filter(isValidPurchaseMotion);
  const purchaseMotions = validPurchaseMotions.length > 0 ? validPurchaseMotions : ['TALK_TO_SALES_FALLBACK'];
  const evaluatedPurchaseMotion = purchaseMotions[0];
  if (evaluatedPurchaseMotion !== undefined && !isValidTalkToSalesPurchaseMotion(evaluatedPurchaseMotion)) {
    return {
      loading: false,
      error: new Error(`invalid TTS PurchaseMotion: ${String(evaluatedPurchaseMotion)}`),
      purchaseMotion: undefined
    };
  }
  return {
    loading,
    error: undefined,
    purchaseMotion: evaluatedPurchaseMotion
  };
};